import React from 'react';

import { ManageSharingSection, DetailSection, ViewLayout } from '../components';
import { RibbonBar, RibbonDivider } from 'common/components';

import { FormHistoryDownloadSection } from './components';

const FormHistory = () => {
  return (
    <RibbonBar>
      <ManageSharingSection />
      <DetailSection />
      <ViewLayout disabled />
      <RibbonDivider />
      <FormHistoryDownloadSection />
      {/* <AdvanceStack isDisabled /> */}
    </RibbonBar>
  );
};

export default FormHistory;
